module.exports = __webpack_public_path__ + "static/team-0481051bcab93ec78d7c3461b2287e9c.jpg";